import { useRef } from 'react';

import { useMap } from '../hooks/useMap';
import { useMapMarker } from '../hooks/useMapMarker';
import { StyledMap } from '../style';
import { GoogleMapProps } from '../types';

export const Map = ({ height, hideMarker, ...options }: GoogleMapProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const map = useMap(ref, options);

  useMapMarker({ map, position: options.center }, hideMarker);

  return <StyledMap {...{ height, ref }} />;
};
